import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LoginForm } from './components/auth/LoginForm';
import { AdminDashboard } from './pages/AdminDashboard';
import { OwnerDashboard } from './pages/OwnerDashboard';
import { UsersPage } from './pages/UsersPage';
import { StatsPage } from './pages/StatsPage';
import { PropertyDetailPage } from './pages/PropertyDetailPage';
import { PropertyReportPage } from './pages/PropertyReportPage';
import { ReportsPage } from './pages/ReportsPage';
import { DataManagementPage } from './pages/DataManagementPage';
import { MonthlyDataPage } from './pages/MonthlyDataPage';
import { useAuthStore } from './store/authStore';

function App() {
  const { user, initializeAuth } = useAuthStore();

  useEffect(() => {
    initializeAuth().catch(console.error);
  }, [initializeAuth]);

  return (
    <Router>
      <Routes>
        <Route path="/" element={!user ? <LoginForm /> : <Navigate to="/dashboard" />} />
        <Route 
          path="/dashboard" 
          element={
            user ? (
              user.role === 'admin' ? <AdminDashboard /> : <OwnerDashboard />
            ) : (
              <Navigate to="/" />
            )
          } 
        />
        <Route 
          path="/users" 
          element={
            user?.role === 'admin' ? <UsersPage /> : <Navigate to="/dashboard" />
          } 
        />
        <Route 
          path="/stats" 
          element={
            user?.role === 'admin' ? <StatsPage /> : <Navigate to="/dashboard" />
          } 
        />
        <Route 
          path="/reports" 
          element={
            user?.role === 'admin' ? <ReportsPage /> : <Navigate to="/dashboard" />
          } 
        />
        <Route 
          path="/data-management" 
          element={
            user?.role === 'admin' ? <DataManagementPage /> : <Navigate to="/dashboard" />
          } 
        />
        <Route 
          path="/monthly-data" 
          element={
            user?.role === 'admin' ? <MonthlyDataPage /> : <Navigate to="/dashboard" />
          } 
        />
        <Route 
          path="/property/:id" 
          element={
            user ? <PropertyDetailPage /> : <Navigate to="/" />
          } 
        />
        <Route 
          path="/property/:id/report" 
          element={
            user ? <PropertyReportPage /> : <Navigate to="/" />
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;
